import useScrollAnimation from "@/hooks/useScrollAnimation";
import { aboutData } from "@/mocks/homeData";

export default function AboutSection() {
  const { ref, isVisible } = useScrollAnimation(0.12);

  return (
    <section id="about" className="w-full py-16 md:py-24 bg-background-50">
      <div
        ref={ref}
        className={`w-full px-4 md:px-6 lg:px-10 transition-all duration-700 ${
          isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
        }`}
      >
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          <div className="w-full lg:w-1/2">
            <div className="relative rounded-xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20corporate%20office%20interior%20with%20team%20collaboration%20area%2C%20glass%20walls%2C%20warm%20natural%20lighting%2C%20professional%20business%20environment%2C%20minimal%20clean%20design%2C%20neutral%20warm%20tones%2C%20editorial%20photography%20quality&width=800&height=600&seq=about-2026-overhaul&orientation=landscape"
                alt="RedeemSoft headquarters in Iselin, New Jersey"
                className="w-full h-64 md:h-80 lg:h-96 object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/50 via-transparent to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-4 md:p-6">
                <p className="text-background-50 font-heading font-medium text-sm md:text-base">
                  Iselin, New Jersey — Headquartered since 2004
                </p>
              </div>
            </div>
          </div>

          <div className="w-full lg:w-1/2">
            <span className="text-xs md:text-sm font-semibold text-primary-500 uppercase tracking-widest">
              {aboutData.label}
            </span>
            <h2 className="font-heading font-bold text-xl md:text-3xl lg:text-4xl text-foreground-950 mt-3 mb-5 leading-tight text-balance">
              {aboutData.headline}
            </h2>

            <div className="space-y-4 text-sm md:text-base text-foreground-700 leading-relaxed mb-8">
              {aboutData.paragraphs.map((p, i) => (
                <p key={i}>{p}</p>
              ))}
            </div>

            <div className="grid grid-cols-2 gap-3 md:gap-4">
              {aboutData.stats.map((stat) => (
                <div
                  key={stat.label}
                  className="bg-background-100 rounded-lg p-4 md:p-5 border border-background-200/70"
                >
                  <div className="font-heading font-bold text-xl md:text-3xl text-primary-500 leading-none">
                    {stat.value}
                  </div>
                  <div className="text-xs md:text-sm font-semibold text-foreground-900 mt-1.5">
                    {stat.label}
                  </div>
                  <div className="text-xs text-foreground-500 mt-0.5 leading-tight">
                    {stat.detail}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}